import { PrimeReactProvider } from 'primereact/api';
import React from 'react';
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from 'react-router-dom';
import { FilterProvider } from './context/FilterContext';
import { ShoppingCartProvider } from './context/ShoppingCartContext';
import SplashScreen from './pages/splash/Splash';
import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.min.css';
import 'primereact/resources/themes/md-light-indigo/theme.css';
import { BusinessUnitProvider } from './components/BusinessUnit/BusinessUnitProvider';
import ChoiceCustomer from './pages/choiceCustomer/ChoiceCustomer';
import Products from './pages/home/Products';
import { AuthContextProvider } from './context/AuthContext';
import { PrivateRoute } from './routes/PrivateRoute';
import { PublicRoute } from './routes/PublicRoute';
import EnvironmentBar from './components/Environment/EnvironmentBar';

const App: React.FC = () => {
  return (
    <div className="App">
      <EnvironmentBar />
      <Router>
        <ShoppingCartProvider>
          <AuthContextProvider>
            <PrimeReactProvider value={{ unstyled: false }}>
              <FilterProvider>
                <BusinessUnitProvider>
                  <Routes>
                    <Route
                      path="/"
                      element={
                        <PublicRoute redirectTo="/all-products">
                          <SplashScreen />
                        </PublicRoute>
                      }
                    />
                    <Route
                      path="/all-products"
                      element={
                        <PrivateRoute requireValidation={true}>
                          <Products />
                        </PrivateRoute>
                      }
                    />
                    <Route
                      path="/choiceCustomer"
                      element={
                        <PrivateRoute requireValidation={true}>
                          <ChoiceCustomer />
                        </PrivateRoute>
                      }
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </BusinessUnitProvider>
              </FilterProvider>
            </PrimeReactProvider>
          </AuthContextProvider>
        </ShoppingCartProvider>
      </Router>
    </div>
  );
};

export default App;
